
import React, { useEffect } from "react"
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from "@mui/material/Box"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
// Css file
import "./index.css"
import Typography from "@mui/material/Typography";
import ErrorIcon from '@mui/icons-material/Error';

const LOT_AGE = "lottery-agency"
const SUP_LOT = "provider-lottery"

// ===================== | CONCILIATION MODAL | ===============================

const ConciliationModal = ({ data, setData }) => {
  const { conciliationData } = data
  const errorRows = buildRows(conciliationData)

  // Section: Modal

  const handleOpen = () => {
    setData((prev) => ({ ...prev, open: false }))
  }

  const descriptionElementRef = React.useRef(null);
  useEffect(() => {
    if (data.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [data.open, descriptionElementRef]);

  // Section: Tab
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      scroll='paper'
      open={data.open}
      onClose={handleOpen}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        className="title-dialog"
      >
        Error conciliación
        <ErrorIcon color="error" />
      </DialogTitle>
      <DialogContent>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Agencias" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <ConciliationTable
            rows={errorRows}
            desc="Detalle de conciliación de premios para agencias"
          />
        </CustomTabPanel>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOpen}>Ok</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConciliationModal

// ========================= | AUX FUNCTIONS | =================================

function buildRows(moveData, type) {
  let moveRows = []
  moveData.forEach((data) => {
    let pdv = `${data.agency.number}-${data.agency.subNumber | 0}`
    data.prizeCategoryConciliation.forEach((item, index) => {
      if (index !== 0) {
        pdv = null
      }
      const catPrem = item.prizeCategoryId
      const cantProv = item.fileQty
      const cantNoa = item.registeredQty

      const newRegister = { pdv, catPrem, cantProv, cantNoa }
      moveRows.push(newRegister)
    })

  })

  return moveRows
}

// ======================== | TABS - AUX COM/FUNC | ============================

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// ============================== | TABLE | =====================================

function ConciliationTable(props) {
  const { rows, desc } = props

  return (
    <>
      <Typography
        className="desc"
        variant="h6"
      >
        {desc}
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className="cell-separator">Pdv</TableCell>
              <TableCell className="cell-separator" align="center">Catategoría Premios</TableCell>
              <TableCell align="center">Cant. Prov.</TableCell>
              <TableCell align="center">Cant. Noa</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.name}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell
                  className="cell-separator font-bold"
                  component="th"
                  scope="row">{row.pdv}</TableCell>
                <TableCell
                  className="cell-separator"
                  align="center"
                >
                  {row.catPrem}
                </TableCell>
                <TableCell
                  className={`${row.returnedStatus !== "OK" ? "cell-error" : ""}`}
                  align="center"
                >
                  {row.cantProv}
                </TableCell>
                <TableCell
                  className={`${row.returnedStatus !== "OK" ? "cell-error" : ""}`}
                  align="center"
                >
                  {row.cantNoa}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
